import React from "react";
import { Card, Box, Typography, Button, CardActions } from "@mui/joy";

function ContactRepresentative({ setOpen }) {
  const goToLegislators = () => {
    window.open("/legislators", "_self");
  };

  return (
    <Card
      variant="soft"
      color="primary"
      size="lg"
      orientation="horizontal"
      sx={{
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-around",
        alignItems: "stretch",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: { xs: "100%", md: "55%" },
        }}
      >
        <Typography level="h3"> Contact you representative </Typography>
        <Typography level="body-lg" sx={{ textAlign: "left" }}>
          Your voice matters—consider contacting your representative about these
          important issues!
        </Typography>
      </Box>
      <CardActions sx={{ display: "flex", gap: { xs: 2, md: 2 }, paddingTop: 0, flexDirection: { xs: "column", md: "row" }, alignItems: { xs: "stretch", md: "center" } }}>
        <Button
          variant="outlined"
          color="primary"
          size="lg"
          sx={(theme) => ({
            borderColor: theme.vars.palette.primary[600],
            color: theme.vars.palette.primary[600],
          })}
          onClick={() => goToLegislators()}
        >
          View all legislators
        </Button>
        <Button
          variant="solid"
          color="primary"
          size="lg"
          onClick={() => setOpen(true)}
        >
          Get started
        </Button>
      </CardActions>
    </Card>
  );
}

export default ContactRepresentative;
